function ExpandMore({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9995 15.0387L6.3457 9.38488L7.39953 8.33105L11.9995 12.9311L16.5995 8.33105L17.6534 9.38488L11.9995 15.0387Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ExpandMore;
